import React from 'react';
import './ReadinessForm.css';
import './Overview.css';

const ReadinessForm = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <h1>Business Readiness Form</h1>
          <div className="page-meta">Draft saved automatically</div>
        </div>
      </div>

      <div className="card">
        <div className="form-group">
          <label className="form-label">1. What problem does TwinOxis's Digital Twin solution solve, and for whom?</label>
          <textarea 
            className="form-textarea" 
            defaultValue="Real-time simulation for manufacturing plants to predict equipment failure before it happens..."
          ></textarea>
        </div>

        <div className="form-group">
          <label className="form-label">2. What is the current stage of the product?</label>
          <textarea 
            className="form-textarea" 
            placeholder="Type your answer..."
          ></textarea>
        </div>

        <button className="save-btn">Save draft</button>
      </div>
    </div>
  );
};

export default ReadinessForm;
